<template>
  <div class="mybookshelf-view">
    <nav-menu :navMenuList="navMenuList"
    :activeIndex="activeIndex"
    @handleSelect="handleSelect"></nav-menu>
    <div class="search-panel">
      <div class="allPage">
      </div>
      <!-- <div class="d-search">
        <input type="text" placeholder="请输入书籍名称">
        <button @click="cliclSearch">
          <i class="el-icon-search"></i>
        </button>
      </div> -->
    </div>
    <ul class="list-view">
      <li v-for="(item,index) in list" :key="index">
        <div class="left">
          <img :src="item.imgUrl" alt="">
        </div>
        <div class="right">
          <strong>{{item.name}}</strong>
          <p class="p-name">{{item.author}}</p>
          <el-rate
            class="star"
            v-model="item.star"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
          <p>
            {{item.time}}购入
          </p>
          <p>
            已阅读{{item.read}}
          </p>
          <button @click="reading(item)">继续阅读</button>
        </div>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage3"
        :page-size="pages.size"
        layout="prev, pager, next, jumper"
        :total="pages.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
import Axios from 'axios'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      currentPage3: 5,
      activeIndex: '0',
      navMenuList: [{
        text: '我的书架',
        pathName: 'MyBookshelf'
      }],
      userId: '',
      pages: {
        size: 10,
        start: 0,
        total: 0
      },
      list: []
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      this.pages.start = (val - 1) * this.pages.size
      this.getMyBookshelf()
    },
    cliclSearch () {
      alert('搜索')
    },
    handleSelect (key) {
      this.activeIndex = key
    },
    getMyBookshelf () {
      let par = {
        userId: this.userId,
        start: this.pages.start,
        length: this.pages.size
      }
      Axios.post(this.$allUrl.getMyBookshelf, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          let list = res.data
          this.list = []
          const imgAdmin = this.$allUrl.imgAdmin
          this.pages.total = res.recordsTotal
          list.forEach(e => {
            this.list.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              author: e.bookAuthors,
              time: e.paymentTime,
              star: e.starLevel,
              read: e.rate,
              schedule: e.schedule
            })
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    reading (row) { // 在线试读
      let routeData = this.$router.resolve({
        name: 'Book',
        query: {
          bookId: row.id,
          type: 2,
          jd: row.schedule,
          bfb: Number(row.read)
        }
      })
      window.open(routeData.href, '_blank')
    }
  },
  mounted () {
    const userMsg = this.$store.state.userMsg
    if (userMsg) {
      this.userId = userMsg.id
      this.getMyBookshelf()
    }
  }
}
</script>
<style lang="less" scoped>
  .mybookshelf-view{
    position: relative;
  }
  .pagination{
    text-align: right;
    padding: 50px 0;
  }
  .search-panel{
    height: 30px;
    width: 860px;
    position: absolute;
    right: 0;
    top: -2px;
    display: flex;
    line-height: 30px;
    .allPage{
      flex: 1;
      color: #7B6EA3;
      font-size: 14px;
      font-weight: 600;
    }
    .d-search{
      line-height: 20px;
      button{
        background-color: #B7151E;
        border: 0;
        outline: none;
        cursor: pointer;
        color: white;
        padding: 0 10px;
        height: 100%;
        float: right;
        font-size: 16px;
      }
      input{
        width: 200px;
        outline: none;
        border: 2px solid #B7151E;
        height: 24px;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      }
    }
  }
  .list-view{
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    li{
      max-width: 50%;
      min-width: 50%;
      display: flex;
      padding: 40px 0;
      border-bottom: 1px solid #DBDBDB;
      p{
        padding: 0;
        margin: 0;
        font-size: 14px;
        padding-bottom: 10px;
        color: #9F9F9F;
      }
      .left{
        padding: 0 20px;
        img{
          width: 150px;
          height: 180px;
        }
      }
      .right{
        strong{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          height: 41px;
        }
        .star{
          padding-bottom: 10px;
        }
        .p-name{
          padding-top: 10px;
        }
        button{
          width: 100px;
          height: 28px;
          background-color: #B7151E;
          color: white;
          outline: none;
          border: 0;
          border-radius: 6px;
          cursor: pointer;
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #F76B6E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyBookshelf/mybookshelf.vue


// WEBPACK FOOTER //
// src/components/Personal/MyBookshelf/mybookshelf.vue